import { render, staticRenderFns } from "./cupo-form.vue?vue&type=template&id=a2d700b8&"
import script from "./cupo-form.vue?vue&type=script&lang=js&"
export * from "./cupo-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports